import React, { useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import TextTool from './TextTool';
import MultiEditingTool from './MultiEditingTool';
import ShapeTool from './ShapeTool';
import ImageTool from './ImageTool';
import LayersTool from './LayersTool';
import { Context } from '@routes/private/Editor/Context';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import BrandLibraryTool from './BrandLibraryTool';
import { ITemplate } from '@state/templates/types';

const ToolBar:React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const [showMultiEditing, setShowMultiEditing] = React.useState(false);
  const authContext = useContext(AuthContext);
  const userRole = (authContext.userData && authContext.userData.profile && authContext.userData.profile.role) ? authContext.userData.profile.role : "";
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const layersPanelAdmitedRoles = (dsConfig && dsConfig.editorConfig && dsConfig.editorConfig.layersPanelAdmitedRoles) ? dsConfig.editorConfig.layersPanelAdmitedRoles : []; 

  useEffect(() => {
    if (!context.multiEditingConfig || context.multiEditingConfig?.categories.length===0) {
      setShowMultiEditing(false);
    }
    else setShowMultiEditing(true);    
  }, [context.multiEditingConfig?.categories.length]);  
  return (
    
    <S.Root>
      {
      context.editorStatus.editMode ? 
      <>
      {
        showMultiEditing && 
        <MultiEditingTool />
      }
      <BrandLibraryTool/>
      <TextTool />
      <ShapeTool />
      <ImageTool />
      {
        layersPanelAdmitedRoles.includes(userRole) && 
        <LayersTool />
      }
      </>
      :
      <></>  
      }
    </S.Root>            
  );
}

export default ToolBar;